(() => {
  let observer;
  let frame = 0;
  function update() {
    frame = 0;
    const logo = document.querySelector('.vr-home-brand');
    if (!logo) { document.body.classList.remove('vr-home-header-shown'); return; }
    const revealAfter = 38;
    // Reveal the full white header after roughly one CSS centimetre of scrolling.
    document.body.classList.toggle('vr-home-header-shown', window.scrollY >= revealAfter);
    const hero = logo.closest('.vr-hero'), photo = hero?.querySelector('.vr-hero-picture img');
    if (window.innerWidth >= 750 && photo?.naturalWidth) {
      const area = hero.getBoundingClientRect(), rect = photo.getBoundingClientRect();
      const height = Math.min(rect.width / photo.naturalWidth, rect.height / photo.naturalHeight) * photo.naturalHeight;
      // The wall/floor join is at row 499 in the approved 778px desktop photograph.
      const floor = rect.top + (rect.height - height) / 2 + height * (499 / 778) - area.top;
      hero.style.setProperty('--vr-floor-line', floor + 'px');
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  function init() {
    observer?.disconnect();
    const logo = document.querySelector('.vr-home-brand');
    if (logo) { observer = new ResizeObserver(schedule); observer.observe(logo); const hero = logo.closest('.vr-hero'); if (hero) observer.observe(hero); hero?.querySelector('.vr-hero-picture img')?.addEventListener('load', schedule, {once:true}); }
    update();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
